import { render, staticRenderFns } from "./management.vue?vue&type=template&id=6943bc80&scoped=true&"
import script from "./management.vue?vue&type=script&lang=js&"
export * from "./management.vue?vue&type=script&lang=js&"
import style0 from "./management.vue?vue&type=style&index=0&id=6943bc80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6943bc80",
  null
  
)

export default component.exports